import { RoleService } from "./lib/services/role_service";

export * from "./lib/types/role_service_types";

export const roleService = new RoleService();
